module.exports = __webpack_public_path__ + "static/our-solutions-shipping-express-fast-b5fc364e235295846bd1f8f7ec4db846.png";